import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-skeleton-loader',
    templateUrl: './skeleton-loader.component.html',
    styleUrls: ['./skeleton-loader.component.scss'],
    // imports: [NgStyle, NgClass]
})
export class SkeletonLoaderComponent implements OnInit {
    @Input() width: string = '100%';
    @Input() height: string = '100%';
    @Input() borderRadius: string = '4px';
    @Input() type: string = '';
    @Input() set rows(value: number){
      if(value){
        this.rowArray = Array.from({ length: value })
      }
    };
    rowArray = Array.from({ length: 1 })

    bars: { label: string; height: number }[] = [];

  ngOnInit(): void {
    if(this.type == 'bar'){
      const labels = ['Jan', 'Feb', 'Mar', 'Apr', 'May'];
      this.bars = labels.map(label => ({
        label,
        height: 0 // Start with 0 height
      }));

      // Animate heights after component renders
      setTimeout(() => {
        this.bars = this.bars.map(bar => ({
          ...bar,
          height: Math.floor(Math.random() * 40) + 60 // Animate to 60%–100%
        }));
      }, 100);
    }
  }
}
